import { FC } from "react";
import { Text } from "@mantine/core";
import DocList from "../Components/DocList";
import { File as FileEnum } from "@funded-here-interface/common/src/constant/enum";
import { getFilteredDocuments, getNameFromPath } from "../Components/utils";

interface DocumentRendererProps {
  documents: string[];
  header: string;
  fileType: FileEnum;
  hasBeenSentToWallex: boolean;
  uploadedFiles: string[];
  excludedFiles: string[];
  downloadDocument: (path: string, fileName: string) => void;
  toggleExcludeDocument: (path: string) => void;
  failedDocuments: any[];
  uploadPartialSuccess: boolean;
  classes: { header: string };
}

/**
 * Renders a document section with conditional logic for sent/not sent states
 */
export const DocumentRenderer: FC<DocumentRendererProps> = ({
  documents,
  header,
  fileType,
  hasBeenSentToWallex,
  uploadedFiles,
  excludedFiles,
  downloadDocument,
  toggleExcludeDocument,
  failedDocuments,
  uploadPartialSuccess,
  classes,
}) => {
  const filteredDocs = getFilteredDocuments(
    documents,
    hasBeenSentToWallex,
    uploadedFiles,
    excludedFiles,
    true
  );

  const noDocsToShow =
    getFilteredDocuments(
      documents,
      hasBeenSentToWallex,
      uploadedFiles,
      excludedFiles,
      false
    ).length === 0 && documents.length > 0;

  // Show "No documents sent" message
  if (hasBeenSentToWallex && noDocsToShow) {
    return (
      <div>
        <Text className={classes.header}>{header}</Text>
        <Text color="dimmed" italic align="center" py="md" size="lg">
          No {header} has been sent.
        </Text>
      </div>
    );
  }

  // Show document list if there are filtered documents
  if (filteredDocs.length > 0) {
    return (
      <DocList
        documents={filteredDocs}
        header={header}
        fileType={fileType}
        downloadDocument={downloadDocument}
        getNameFromPath={getNameFromPath}
        toggleExcludeDocument={toggleExcludeDocument}
        excludedFiles={excludedFiles}
        hasBeenSentToWallex={hasBeenSentToWallex}
        uploadedFiles={uploadedFiles}
        failedDocuments={failedDocuments}
        uploadPartialSuccess={uploadPartialSuccess}
      />
    );
  }

  // Don't render anything if no documents
  return null;
};
